function initializeQuickBuy() {
  const cartAdds = document.querySelectorAll(".sizes-box:not([data-quickbuy-initialized])");
  const quickButtons = document.querySelectorAll(".quickBuy:not([data-quickbuy-initialized])");
  const quickClose = document.querySelectorAll(".closequickbuy:not([data-quickbuy-initialized])");
  const featuredImages = document.querySelectorAll("figure.product-featured-image:not([data-quickbuy-initialized])");

  cartAdds.forEach((box) => {
    box.addEventListener("click", () => {
      const variantId = box.querySelector("button")?.dataset.cartAddCustom;
      if (variantId) {
        CartJS.addItem(variantId, 1, {}, {
          success: () => {
            // Despacha eventos relevantes
            dispatchCustomEvent("cart:item-added");
            dispatchCustomEvent("line-item:change:end");
            dispatchCustomEvent("cart:refresh");
            document.dispatchEvent(new CustomEvent("productAdded"));

            // Abre el drawer del carrito
            const cartDrawer = document.querySelector("#Cart-Drawer");
            if (cartDrawer) {
              cartDrawer.classList.add("active");
              document.body.classList.add("open-cart", "open-cc");
              cartDrawer.querySelector(".product-recommendations--full")?.classList.add("active");
            }

            // Reasigna listeners en el drawer
            setTimeout(() => {
              const termsCheckbox = document.getElementById("CartDrawerTerms");
              const checkoutButton = document.querySelector(".button.checkout");

              if (termsCheckbox && checkoutButton) {
                termsCheckbox.addEventListener("change", () => {
                  if (termsCheckbox.checked) {
                    checkoutButton.classList.remove("disabled");
                    checkoutButton.removeAttribute("disabled");
                  } else {
                    checkoutButton.classList.add("disabled");
                    checkoutButton.setAttribute("disabled", true);
                  }
                });

                // Actualizar estado inicial
                if (termsCheckbox.checked) {
                  checkoutButton.classList.remove("disabled");
                  checkoutButton.removeAttribute("disabled");
                } else {
                  checkoutButton.classList.add("disabled");
                  checkoutButton.setAttribute("disabled", true);
                }
              }
            }, 100); // Timeout para asegurar que el DOM esté actualizado
          },
          error: (errorThrown) => console.error("Error adding item to cart:", errorThrown),
        });
      }
    });
    box.setAttribute("data-quickbuy-initialized", "true");
  });

  quickButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll(".quickbuy-section").forEach((container) => {
        container.style.display = "none";
      });

      const sizesContainer = button.closest("figure.product-featured-image")?.querySelector(".quickbuy-section");
      if (sizesContainer) {
        sizesContainer.style.display = "flex";
      }
    });
    button.setAttribute("data-quickbuy-initialized", "true");
  });

  quickClose.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const sizesContainer = button.closest("figure.product-featured-image")?.querySelector(".quickbuy-section");
      if (sizesContainer) {
        sizesContainer.style.display = "none";
      }
    });
    button.setAttribute("data-quickbuy-initialized", "true");
  });

  featuredImages.forEach((image) => {
    image.addEventListener("mouseover", () => {
      document.querySelectorAll(".quickbuy-section").forEach((container) => {
        container.style.display = "none";
      });
      const sizesContainer = image.querySelector(".quickbuy-section");
      if (sizesContainer) {
        sizesContainer.style.display = "flex";
      }
    });

    image.addEventListener("mouseout", () => {
      const sizesContainer = image.querySelector(".quickbuy-section");
      if (sizesContainer) {
        sizesContainer.style.display = "none";
      }
    });

    image.setAttribute("data-quickbuy-initialized", "true");
  });
}

// Reasignar listeners en paginación
initializeQuickBuy();
document.addEventListener("pagination:page-changed", initializeQuickBuy);
